module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "half-circle-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle circle-1",
    style: (_vm.circle1Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle-2",
    style: (_vm.circle2Style)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f842724"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/HalfCircleSpinner.vue
// module id = 2159
// module chunks = 1